/**
 * Profile source data for ivansridana.com
 * Transcribed from LinkedIn screenshots (handover Rev 5, Sep 2026).
 * dataSource field indicates origin: "screenshot" | "ivan-direct" | "draft-copy"
 * 
 * Internal note: KRTMI UI and Tim Robotika show Jan 2023 in Experience
 * but Nov 2022 in Organizations. Experience dates used as primary reference.
 * Conflict logged here; not surfaced to visitors.
 */

export const experience = [
  {
    id: "EY-SENIOR",
    role: "Senior Technology Consultant, Cybersecurity",
    org: "EY",
    orgFull: "Ernst & Young Indonesia",
    period: "Sep 2025 - Present",
    type: "Full-time",
    location: "Jakarta, Indonesia",
    workMode: "On-site",
    active: true,
    groupWith: "EY-CONSULTANT",
    description: null,
    dataSource: "screenshot",
  },
  {
    id: "EY-CONSULTANT",
    role: "Technology Consultant, Cybersecurity GRC",
    org: "EY",
    orgFull: "Ernst & Young Indonesia",
    period: "Aug 2024 - Sep 2025",
    type: "Full-time",
    location: "Jakarta, Indonesia",
    workMode: "On-site",
    active: false,
    groupWith: "EY-SENIOR",
    highlights: [
      "Cybersecurity maturity assessments for financial services and telecommunications organizations.",
      "Controls testing and gap analysis against governance frameworks.",
      "Reviews of IT operations, SLA adherence, and incident management processes.",
      "Translating technical findings into practical recommendations aligned to ISO 27001, ISO 20000, NIST CSF, and COBIT 2019.",
    ],
    description:
      "Context from handover; specific task descriptions not visible in screenshot.",
    dataSource: "draft-copy",
  },
  {
    id: "GENBI",
    role: "Bank Indonesia Scholarship Awardee",
    org: "Generasi Baru Indonesia (GenBI)",
    period: "Aug 2023 - Aug 2024",
    type: "Scholarship",
    location: "Jakarta, Indonesia",
    workMode: "Hybrid",
    active: false,
    description: null,
    dataSource: "screenshot",
  },
  {
    id: "BANGKIT",
    role: "Cloud Computing Cohort",
    org: "Bangkit Academy led by Google, Tokopedia, Gojek & Traveloka",
    period: "Feb 2023 - Jul 2023",
    type: "Learning program",
    location: "Indonesia",
    workMode: "Remote",
    active: false,
    skills: ["Containerization", "Google Cloud Platform (GCP)"],
    skillsNote: "Two additional skills visible as +2 in screenshot; not transcribed.",
    description: null,
    dataSource: "screenshot",
  },
  {
    id: "GMF",
    role: "Internet of Things Engineer Intern",
    org: "GMF AeroAsia",
    period: "Apr 2023 - Jun 2023",
    type: "Internship",
    location: "Tangerang, Banten, Indonesia",
    workMode: "On-site",
    active: false,
    highlights: [
      "Worked on recreating industrial-grade anemometers for wind speed and direction monitoring, integrating sensors, data processing, and communication protocols.",
    ],
    skills: ["Network Engineering", "Network Infrastructure"],
    skillsNote: "Two additional skills visible as +2 in screenshot; not transcribed.",
    dataSource: "screenshot",
  },
  {
    id: "IEEE",
    role: "Internal Development Staff",
    org: "IEEE Student Branch Universitas Indonesia",
    period: "Mar 2022 - Jan 2023",
    type: "Student organization",
    location: null,
    workMode: null,
    active: false,
    description: null,
    dataSource: "screenshot",
  },
  {
    id: "KRTMI",
    role: "Programmer",
    org: "KRTMI UI",
    period: "Mar 2021 - Jan 2023",
    type: "University team",
    location: null,
    workMode: null,
    active: false,
    description: null,
    dataSource: "screenshot",
    sourceNotes:
      "Experience section: Jan 2023. Organizations section: Nov 2022. Using Experience date as primary.",
  },
  {
    id: "ROBOTICS",
    role: "Member",
    org: "Tim Robotika Universitas Indonesia",
    period: "Mar 2021 - Jan 2023",
    type: "University team",
    location: null,
    workMode: null,
    active: false,
    description: null,
    dataSource: "screenshot",
    sourceNotes:
      "Experience section: Jan 2023. Organizations section: Nov 2022. Using Experience date as primary.",
  },
];

export const education = [
  {
    id: "UI",
    institution: "Universitas Indonesia",
    degree: "Bachelor of Engineering (BE), Computer Engineering",
    period: "2020 - Aug 2024",
    note: "Start month not available in screenshot.",
    dataSource: "screenshot",
  },
  {
    id: "SMA4",
    institution: "SMA Negeri 4 Denpasar",
    degree: "Mathematics and Natural Science",
    period: "Jul 2017 - May 2020",
    dataSource: "screenshot",
  },
];

export const languages = [
  { lang: "English", level: "Professional working proficiency", dataSource: "screenshot" },
  { lang: "Indonesian", level: "Native or bilingual proficiency", dataSource: "screenshot" },
  { lang: "Japanese", level: "Elementary proficiency", dataSource: "screenshot" },
];

export const awards = [
  {
    id: "GEMASTIK",
    title: "Bronze Medalist, GEMASTIK XV",
    category: "Smart Device, Embedded System & IoT",
    issuer: "Pusat Prestasi Nasional, Kemendikbudristek",
    date: "Nov 2022",
    affiliation: "Universitas Indonesia",
    projectRef: "SENSAMAKARA",
    tempoUrl: "https://www.tempo.co/sains/mahasiswa-ui-raih-7-gelar-juara-gemastik-xv-249747",
    tempoTitle: "Mahasiswa UI Raih 7 Gelar Juara Gemastik XV",
    tempoNote:
      "Seven titles referenced in the headline belong to the UI contingent as a whole, not to Ivan individually. Bronze medal is confirmed by screenshot.",
    dataSource: "screenshot",
  },
  {
    id: "JDIE2023",
    title: "Selected for exhibition, JDIE 2023",
    category: null,
    issuer: "Japan Design, Idea and Invention Expo (JDIE)",
    date: "2023",
    affiliation: "Universitas Indonesia",
    projectRef: "SENSAMAKARA",
    description:
      "Selected for exhibition at the Japan Design, Idea and Invention Expo (JDIE) 2023 through the organizers' professional curation process.",
    labelShort: "Selected for exhibition · JDIE 2023",
    type: "exhibition-selection",
    jdieInfoUrl: "https://www.wiipa.org.tw/edcontent_d.php?id=2233&lang=en&tb=5",
    jdieUrlNote:
      "This URL describes the JDIE 2023 event; it is not proof of individual selection.",
    dataSource: "ivan-direct",
    wordingConstraints:
      "Do not claim: presented in Tokyo, attended, showcased in Japan, represented Indonesia, finalist, winner, medalist.",
  },
  {
    id: "FUJIFILM",
    title: "Runner Up Candidate, SOOC #1 Fujifilm Indonesia",
    issuer: "Fujifilm Indonesia",
    date: "Apr 2021",
    type: "photography",
    note: "Status is Runner Up Candidate, not confirmed runner-up. Retain exact wording.",
    dataSource: "screenshot",
  },
  {
    id: "UDAYANA-2020",
    title: "1st Place, Electrical and Computer Quiz Competition",
    issuer: "Universitas Udayana",
    date: "Feb 2020",
    affiliation: "SMA Negeri 4 Denpasar",
    dataSource: "screenshot",
    note: "Separate entry from Feb 2019 win. Do not merge.",
  },
  {
    id: "UDAYANA-IT-2019",
    title: "3rd Place, Information Technology Quiz",
    issuer: "Universitas Udayana",
    date: "Oct 2019",
    affiliation: "SMA Negeri 4 Denpasar",
    dataSource: "screenshot",
  },
  {
    id: "UDAYANA-2019",
    title: "1st Place, Electrical and Computer Quiz Competition",
    issuer: "Universitas Udayana",
    date: "Feb 2019",
    affiliation: "SMA Negeri 4 Denpasar",
    dataSource: "screenshot",
    note: "Separate entry from Feb 2020 win. Do not merge.",
  },
  {
    id: "PNB-2018",
    title: "3rd Place, Electrical and Computer Quiz Competition",
    issuer: "Politeknik Negeri Bali",
    date: "Oct 2018",
    affiliation: null,
    dataSource: "screenshot",
    note: "Affiliation not visible in this entry.",
  },
];

export const sensamakara = {
  id: "SENSAMAKARA",
  name: "Sensamakara",
  team: "Universitas Indonesia",
  description:
    "Part of the Universitas Indonesia team behind Sensamakara, an assistive communication project. The system uses blink detection for letter selection, fuzzy text suggestions, and speech synthesis to support communication for people with motor impairments, including those with conditions like ALS.",
  technicalDetail:
    "Computer vision and AI map the face, track eye coordinates, and calculate eye aspect ratio to detect blinks. Blinks select letters on screen. Text suggestions use fuzzy search against a stored dictionary. Formed text is read aloud via speech synthesis.",
  attribution:
    "Team project. Screenshot confirms Ivan's membership; individual component responsibilities are not detailed in the handover.",
  githubUrl: "https://github.com/sensa-makara/mediapipe-node",
  milestones: [
    {
      year: "2022",
      label: "Bronze medal, GEMASTIK XV",
      awardRef: "GEMASTIK",
    },
    {
      year: "2023",
      label: "Selected for exhibition, JDIE",
      awardRef: "JDIE2023",
    },
  ],
  dataSource: "ivan-direct",
};

export const publication = {
  id: "SANUR-SERENE",
  title: "Sanur Serene",
  event: "Artspirasi VI Photo Exhibition",
  publisher: "STIKI",
  date: "18 February 2021",
  type: "photography-exhibition",
  url: null,
  urlNote: "URL not visible in screenshot.",
  dataSource: "screenshot",
};

export const organizations = [
  {
    id: "ORG-KRTMI",
    name: "KRTMI UI",
    role: "Programmer",
    period: "Mar 2021 - Nov 2022",
    affiliation: "University of Indonesia",
    note: "Organizations section period. Experience section shows Jan 2023.",
  },
  {
    id: "ORG-ROBOTICS",
    name: "Tim Robotika Universitas Indonesia",
    role: "Member",
    period: "Mar 2021 - Nov 2022",
    affiliation: "University of Indonesia",
    note: "Organizations section period. Experience section shows Jan 2023.",
  },
  {
    id: "ORG-CINE4",
    name: "CINE4 Foursma",
    role: "Screenwriter, Director of Photography",
    period: "Apr 2019 - May 2020",
    affiliation: "SMA Negeri 4 Denpasar",
    note: "Creative background. Do not modify /photography.",
  },
  {
    id: "ORG-FCC",
    name: "Foursma Computer Club",
    role: "Head of Computer Hardware and Troubleshooting Division",
    period: "Jul 2017 - May 2020",
    affiliation: "SMA Negeri 4 Denpasar",
    note: "Early engineering and leadership background.",
  },
];

export const notes = [
  {
    slug: "policy-is-not-control",
    title: "Why a policy is only the beginning of control assurance",
    status: "draft",
    preview:
      "A policy establishes intent. Whether that intent is implemented, monitored, and effective requires a different kind of evidence.",
  },
  {
    slug: "actionable-recommendations",
    title: "What makes an assessment recommendation actionable",
    status: "draft",
    preview:
      "A finding without a clear path to remediation is an observation, not a recommendation. The gap between the two is where most audit reports stall.",
  },
  {
    slug: "technical-findings-to-management",
    title: "Translating technical findings into management decisions",
    status: "draft",
    preview:
      "Technical accuracy and decision-making relevance are not the same thing. Bridging them requires knowing which details matter at which level.",
  },
];
